export { StatCard } from './StatCard';
export type {
  StatCardProps,
  StatCardSize,
  StatisticItem,
} from './StatCard.props';
